export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10880.c2d1703d.jpg";